export enum Order {
    ASCENDING = 'asc',
    DESCENDING = 'desc',
}

export interface Column<T> {
    title: string;
    key: Extract<keyof T, string>;
    tooltip?: string;
    empty?: boolean;
}